import React from 'react';
import InfoIcon from '@material-ui/icons/Info';

const LabeledInput = ({ light, label, name, info, type, placeholder, disbale, value, changeHandler, ...props }) => {
    return (
        <label {...props} htmlFor={name} className="labeled_input">
            <p style={{ fontWeight: light ? '600' : '' }}>{label}</p>
            <input
                id={name}
                disabled={disbale}
                type={type ? type : 'text'}
                placeholder={placeholder}
                className="labeled_input_field"
                value={value}
                onChange={changeHandler}
            />
            {info && <InfoIcon className="labeled_input_icon" />}
        </label>
    );
};

export default LabeledInput;
